<script setup>
  import { computed } from "vue";

  const props = defineProps({
    variant: {
      type: String,
      default: "default", // default | box
    },
  });
  const variantClass = computed(() => `${props.variant}`);
</script>

<template>
  <n-checkbox-group :class="variantClass" v-bind="$attrs">
    <n-flex align="center" :size="8">
      <slot />
    </n-flex>
  </n-checkbox-group>
</template>

<style lang="scss">
  .n-checkbox-group {
    &.box {
      .n-checkbox {
        height: 48px;
        padding: 0 12px;
        justify-content: center;
        align-items: center;
        border-radius: 0.625rem;
        border: 1px solid var(--smoe-border);
        background: var(--smoe-white);
        --n-size: 1rem !important;
        --n-label-padding: 0 0 0 0.25rem !important;
        .n-checkbox-box-wrapper {
          .n-checkbox-box {
            background-color: transparent !important;
            background-size: 16px auto;
            background-repeat: no-repeat;
            background-position: center;
            background-image: url("@/assets/images/ic_checkbox_box_default.png");
            .n-checkbox-icon {
              svg {
                display: none;
              }
            }
          }
          .n-checkbox-box__border {
            display: none;
          }
        }
        .n-checkbox__label {
          color: var(--smoe-gray-800);
          font-size: 1rem;
        }
        &.n-checkbox--checked {
          border: 1px solid var(--smoe-primary-500);
          background: var(--smoe-primary-100);
          .n-checkbox-box-wrapper {
            .n-checkbox-box {
              background-image: url("@/assets/images/ic_checkbox_box_checked.png");
            }
          }
          .n-checkbox__label {
            color: var(--smoe-primary-500);
          }
        }
      }
    }
  }
</style>
